import React from 'react';
import PropTypes from 'prop-types';
import { Card } from 'react-bootstrap';
import Edit from './Edit';
import { eventPropType } from '../../Constants/eventTypes';

const EventSelect = ({
  iconEventTypes,
  listEventTypes,
  select,
  show,
  valid,
  eventTypeRadio,
  eventTypeSelect,
}) =>
  show && (
    <>
      <Card.Header className="border-0">
        <div className="text-center w-100">
          <h1>Select your event.</h1>
          <p className="lead">
            If you do not see your event category,
            <br />
            please call (844) 747-6240 to confirm event eligibility.
          </p>
        </div>
      </Card.Header>
      <Card.Body>
        <h4 className="text-center d-none d-sm-block">
          Most popular event types:
        </h4>
        <Edit
          select={select}
          valid={valid}
          iconEventTypes={iconEventTypes}
          listEventTypes={listEventTypes}
          eventTypeRadio={eventTypeRadio}
          eventTypeSelect={eventTypeSelect}
        />
      </Card.Body>
    </>
  );
EventSelect.propTypes = {
  iconEventTypes: PropTypes.arrayOf(eventPropType).isRequired,
  listEventTypes: PropTypes.arrayOf(eventPropType).isRequired,
  select: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired,
  valid: PropTypes.bool.isRequired,
  eventTypeRadio: PropTypes.string.isRequired,
  eventTypeSelect: PropTypes.string.isRequired,
};

export default EventSelect;
